import { getParser } from 'bowser';

export default getParser(globalThis.navigator.userAgent);
